export const SelectedQuantityDisplay: React.FC<{ quantity }> = ({ quantity }) => (
  <div className='flex justify-end rounded-lg bg-raspberry p-2 pb-0.5 pt-1 text-caption-500 text-white'>{quantity}</div>
);
